import React, { Component } from "react";
import General from "../../components/settings/General";
import { withRouter } from "react-router-dom";
import UpgradeStatusDialog from "../../components/UpgradeStatusDialog";
import FinishedDialog from "../../components/FinishedDialog";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import UpgradeDialog from "../../components/UpgradeDialog";
import { generateSearchRecords } from "../../util/GenerateSearchRecords";

class GeneralContainer extends Component {
  state = {
    finishedDialogOpen: false,
    days: [],
    daysByKey: {},
    daysLoaded: false,
    sportParks: [],
    sportParksByKey: {},
    sportParksLoaded: false,
    matches: [],
    matchesByKey: {},
    matchesLoaded: false,
    sportParksTemp: undefined,
    divisionsTemp: undefined,
    name: this.props.tournament.name,
    nameDialogOpen: false,
    upgradeDialogOpen: false,
  };

  toggleUpgradeDialog = () => {
    this.setState({
      upgradeDialogOpen: !this.state.upgradeDialogOpen,
    });
  };

  toggleNameDialog = () => {
    this.setState({ nameDialogOpen: !this.state.nameDialogOpen });
  };

  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  };

  handleSubmitName = () => {
    let toUpdate = {};
    toUpdate["name"] = this.state.name;

    const db = window.firebase.firestore();
    let batch = db.batch();
    batch.update(
      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"]),
      toUpdate
    );
    if (this.props.tournament.ia) {
      batch = generateSearchRecords(
        {
          id: this.props.tournament[".key"],
          name: this.state.name,
          date: this.props.tournament.date,
          bgURL: this.props.tournament.bgURL,
          logoURL: this.props.tournament.logoURL,
        },
        batch
      );
    }
    batch.commit();
    this.toggleNameDialog();
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      // enter was pressed
      e.preventDefault();
      this.handleSubmitName();
    }
  };

  handleOnlineCheck = (e) => {
    let online = this.props.tournament.online || false;
    let toUpdate = { online: !online };
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  toggleFinishedDialog = () => {
    this.setState({ finishedDialogOpen: !this.state.finishedDialogOpen });
  };

  handleChange = (e) => {
    let toUpdate = {};
    toUpdate[e.target.name] = e.target.value;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribeDays = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("days")
      .onSnapshot((querySnapshot) => {
        let days = [];
        let daysObj = {};
        querySnapshot.forEach((doc) => {
          let day = doc.data();
          day["id"] = doc.id;
          days.push(day);
          daysObj[doc.id] = doc.data();
        });
        this.setState({
          days: days.sort((a, b) => a.date - b.date),
          daysByKey: daysObj,
          daysLoaded: true,
        });
      });

    this.unsubscribeSportparks = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("sportParks")
      .onSnapshot((querySnapshot) => {
        let sportParks = [];
        let sportParksObj = {};
        querySnapshot.forEach((doc) => {
          let sportPark = doc.data();
          sportPark["id"] = doc.id;
          sportParks.push(sportPark);
          sportParksObj[doc.id] = sportPark;
        });
        this.setState({
          sportParks: sportParks.sort((a, b) => {
            if (a.num > b.num) {
              return 1;
            } else if (a.num < b.num) {
              return -1;
            }
            if (Number(a.id) > Number(b.id)) {
              return 1;
            } else if (Number(a.id) < Number(b.id)) {
              return -1;
            } else {
              return 0;
            }
          }),
          sportParksByKey: sportParksObj,
          sportParksLoaded: true,
          sportParksTemp: undefined,
        });
      });

    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    this.unsubscribeMatches = tournamentRef
      .collection("matches")
      .onSnapshot((querySnapshot) => {
        let matches = [];
        let matchesByKey = {};
        querySnapshot.forEach(function (doc) {
          let match = doc.data();
          if (match.day === undefined) {
            match["day"] = "0";
          }
          match["id"] = doc.id;
          matches.push(match);
          matchesByKey[doc.id] = match;
        });

        this.setState({
          matches: matches,
          matchesByKey: matchesByKey,
          matchesLoaded: true,
        });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribeDays();
    this.unsubscribeSportparks();
    this.unsubscribeMatches();
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const locations = this.state.sportParks.slice();
    const [removed] = locations.splice(result.source.index, 1);
    locations.splice(result.destination.index, 0, removed);

    const db = window.firebase.firestore();
    let batch = db.batch();
    const locationsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("sportParks");
    let sportParksTemp = [];
    locations.forEach((l, i) => {
      let location = locations[i];
      location["num"] = i;
      sportParksTemp.push(location);
      batch.update(locationsRef.doc(l.id), { num: i });
    });
    this.setState({ sportParksTemp: sportParksTemp });
    batch.commit().catch((error) => {
      console.log(error.message);
      this.setState({ sportParksTemp: undefined });
    });
  };

  onDragEndDivision = (result) => {
    if (!result.destination) {
      return;
    }

    const divisions = this.props.divisions.slice();
    const [removed] = divisions.splice(result.source.index, 1);
    divisions.splice(result.destination.index, 0, removed);

    const db = window.firebase.firestore();
    let batch = db.batch();
    const divisionsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("divisions");

    let divisionsTemp = [];

    divisions.forEach((l, i) => {
      let division = divisions[i];
      division["num"] = i;
      divisionsTemp.push(division);
      batch.update(divisionsRef.doc(l.id), { num: i });
    });

    this.setState({ divisionsTemp: divisionsTemp });

    batch
      .commit()
      .then(() => {
        this.setState({ divisionsTemp: undefined });
      })
      .catch((error) => {
        console.log(error.message);
        this.setState({ divisionsTemp: undefined });
      });
  };

  render() {
    return (
      <div>
        <UpgradeDialog
          open={this.state.upgradeDialogOpen}
          toggleDialog={this.toggleUpgradeDialog}
          title={languages.upgrade.upgradeTournament}
          description={languages.upgrade.upgradeText1}
          tournament={this.props.tournament}
          user={this.props.user}
          userData={this.props.userData}
          tournamentStatus={this.props.tournamentStatus}
        />
        <FinishedDialog
          open={this.state.finishedDialogOpen}
          handleClose={this.toggleFinishedDialog}
        />
        <Dialog
          open={this.state.nameDialogOpen}
          onClose={this.toggleNameDialog}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {languages.general.nameTournament}
          </DialogTitle>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              fullWidth
              autoFocus
              name="name"
              value={this.state.name}
              onChange={this.handleNameChange}
              onKeyDown={this.handleKeyDown}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.toggleNameDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.handleSubmitName}
              variant="contained"
              color="primary"
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </Dialog>
        {this.state.matchesLoaded &&
          this.state.daysLoaded &&
          this.state.sportParksLoaded && (
            <General
              tournament={this.props.tournament}
              toggleNameDialog={this.toggleNameDialog}
              days={this.state.days}
              matches={this.state.matches}
              sportParks={
                this.state.sportParksTemp
                  ? this.state.sportParksTemp
                  : this.state.sportParks
              }
              divisions={
                this.state.divisionsTemp
                  ? this.state.divisionsTemp
                  : this.props.divisions
              }
              onDragEnd={this.onDragEnd}
              onDragEndDivision={this.onDragEndDivision}
              tournamentStatus={this.props.tournamentStatus}
              toggleFinishedDialog={this.toggleFinishedDialog}
              handleOnlineCheck={this.handleOnlineCheck}
              user={this.props.user}
              userStatus={this.props.userStatus}
              toggleUpgradeDialog={this.toggleUpgradeDialog}
            />
          )}
        {this.props.upgrade && (
          <UpgradeStatusDialog tournament={this.props.tournament} />
        )}
      </div>
    );
  }
}

export default withRouter(GeneralContainer);
